import { AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title = 'juridico-tapia';
  isRecaptchaBadgeVisible = false;
  private recaptchaObserver: MutationObserver | null = null;
  private recaptchaCheckTimer: number | null = null;

  constructor(
    public router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  ngAfterViewInit(): void {
    if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') {
      return;
    }

    this.ngZone.runOutsideAngular(() => {
      this.updateRecaptchaBadgeState();

      this.recaptchaObserver = new MutationObserver(() => {
        this.updateRecaptchaBadgeState();
      });

      this.recaptchaObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true
      });

      this.recaptchaCheckTimer = window.setInterval(() => {
        this.updateRecaptchaBadgeState();
      }, 750);
    });
  }

  ngOnDestroy(): void {
    if (this.recaptchaObserver) {
      this.recaptchaObserver.disconnect();
    }

    if (this.recaptchaCheckTimer !== null) {
      window.clearInterval(this.recaptchaCheckTimer);
    }
  }

  get isAdminRoute(): boolean {
    return this.router.url && this.router.url.indexOf('/admin') === 0;
  }

  private updateRecaptchaBadgeState(): void {
    const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
    const isVisible = badge ? this.isElementVisible(badge) : false;

    if (isVisible === this.isRecaptchaBadgeVisible) {
      return;
    }

    this.ngZone.run(() => {
      this.isRecaptchaBadgeVisible = isVisible;
      this.changeDetectorRef.markForCheck();
    });
  }

  private isElementVisible(element: HTMLElement): boolean {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.opacity !== '0' &&
      rect.width > 0 &&
      rect.height > 0;
  }
}
